import React from 'react'

const Contact = () => {
    return (
        <div>
            <section className="page-section" id="contact">
        <div className="m-auto">
        <div className="text-center">
            <h2 className="section-heading text-uppercase">Contactenos</h2>
        </div>

        <form id="contactForm" >
            <div className="row  mb-2 m-auto mx-md-5">
                <div className="col-md-6">
                    <div className="form-group">
                        <input className="form-control" id="name" type="text" placeholder="Nombre *"
                            data-sb-validations="required" />
                        <div className="invalid-feedback" data-sb-feedback="name:required">Nombre.</div>
                    </div>
                    <div className="form-group">
                        <input className="form-control" id="email" type="email" placeholder="Correo *"
                            data-sb-validations="required,email" />
                        <div className="invalid-feedback" data-sb-feedback="email:required">Correo.</div>
                    </div>
                    <div className="form-group mb-md-0">
                        <input className="form-control" id="phone" type="tel" placeholder="Telefono *"
                            data-sb-validations="required" />
                        <div className="invalid-feedback" data-sb-feedback="phone:required">Celular.</div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group form-group-textarea mb-md-0">
                        <textarea className="form-control" id="message" placeholder="Mensaje *"
                            data-sb-validations="required"></textarea>
                        <div className="invalid-feedback" data-sb-feedback="message:required">Observación.</div>
                    </div>
                </div>
            </div>


            <div className="d-grid mx-md-5 px-3 ">
                <button className="btn btn-outline-light btn-block btn-xl text-uppercase" 
                    type="submit">Enviar mensaje</button>
            </div>
        </form>
    </div>
    </section>
        </div>
    )
}

export default Contact
